// extracted by mini-css-extract-plugin
module.exports =  {"loading-placeholder":"n8JLrOk","loadingPlaceholder":"n8JLrOk"};